'use client';
import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import styles from '../styles/AuthModals.module.css';

export default function LoginModal({
  isOpen,
  onClose,
  // onSwitchToSignup,
  onSubmit,
  onGoogleSignIn,
  email,
  setEmail,
  password,
  setPassword,
  captchaToken,
  setCaptchaToken,
  captchaLoading,
  setCaptchaLoading,
  captchaError,
  setCaptchaError,
  turnstileRef,
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.loginOverlay}>
      <div className={styles.loginDialog}>
        <button className={styles.modalClose} onClick={onClose}>&times;</button>
        <div className={styles.loginContainer}>
          <div className={styles.loginHeader}>
            <h1>Log In</h1>
          </div>
          <div className={styles.loginContent}>
            <form onSubmit={onSubmit}>
              <div className={styles.loginFields}>
                <input
                  type="email"
                  placeholder="Email or username"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {/* CAPTCHA Verification */}
                <div className={styles.captchaContainer}>
                  {captchaLoading && (
                    <div style={{ height: '65px', backgroundColor: '#f3f4f6', borderRadius: '4px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}></div>
                  )}
                  <Turnstile
                    ref={turnstileRef}
                    siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => {
                      setCaptchaToken(token);
                      setCaptchaError('');
                      setCaptchaLoading(false);
                    }}
                    onError={() => {
                      setCaptchaError('CAPTCHA verification failed. Please try again.');
                      setCaptchaLoading(false);
                    }}
                    onExpire={() => {
                      setCaptchaToken('');
                      setCaptchaError('CAPTCHA expired. Please verify again.');
                    }}
                  />
                  {captchaError && (
                    <p style={{ color: '#ef4444', fontSize: '0.875rem', marginTop: '0.5rem' }}>{captchaError}</p>
                  )}
                </div>
                <button type="submit" className={styles.loginBtn} disabled={!captchaToken || captchaLoading}>
                  Log In with Email
                </button>
              </div>
              <div className={styles.divider}><span>OR</span></div>
              <div className={styles.socialButtons}>
                <button
                  type="button"
                  className={`${styles.socialBtn} ${styles.googleBtn}`}
                  onClick={onGoogleSignIn}
                >
                  <img src="/images/google.png" alt="Google" className={styles.socialIcon} />
                  Sign in with Google
                </button>
              </div>
              <div className={styles.termsDisclaimer}>
                By logging in, you agree to our
                <a href="#" className={styles.linkText}> Terms</a> and
                <a href="#" className={styles.linkText}> Privacy Policy</a>.
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}